import { email, helpers, required } from '@vuelidate/validators';
export const NEWSLETTER_TYPES = {
	SUBSCRIBE: 'subscribe',
	UNSUBSCRIBE: 'unsubscribe',
	MODIFY: 'modify'
};
export const FORM_STATES = {
	FORM: 'FORM',
	SENT: 'SENT',
	SUCCESS: 'SUCCESS',
	ALREADY_SUBSCRIBED_ERROR: 'ALREADY_SUBSCRIBED_ERROR',
	NOT_SUBSCRIBED_ERROR: 'NOT_SUBSCRIBED_ERROR',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR',
	GWB_ERROR: 'GWB_ERROR',
	MODIFY: 'MODIFY'
};
export const TOKEN_PARAM = 'token';
export const CLIENT_TYPES = {
	PB: 'PB',
	NON_PB: 'NEM_PB',
	INTEZMENYI: 'INTEZMENYI'
};
export const ERROR_CODES = {
	GWB: 'CLIENT_TYPE_MISMATCH',
	ALREADY_SUBSCRIBED: 'EMAIL_ALREADY_SUBSCRIBED'
};
export const EMAIL_VALIDATION = {
	email: {
		required: helpers.withMessage('Kérjük, adja meg az e-mail címét!', required),
		email: helpers.withMessage('Nem tűnik valós e-mail címnek, kérjük ellenőrizze!', email)
	}
};
export const EMAIL_QUERY_PARAM = 'email';
